module.exports = __webpack_public_path__ + "static/link-impliedtype-do-0b04a05a25357abbad34335361ec9084.png";